const initialState = {
  coursesList: [],
  skillList: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_COURSES_LIST':
      return {
        ...state,
        coursesList: action.data,
      }
    case 'SET_LIST_OF_SKILL':
      return {
        ...state,
        skillList: action?.list,
      }
    default:
      return state
  }
}
